import { Injectable } from '@angular/core';

@Injectable()
export class FundingService {
  yodleeFields = {};


  setLoginForm(value) {
    this.yodleeFields = value;
  }

  getLoginForm() {
    return this.yodleeFields;
  }

}
